import { render, staticRenderFns } from "./Lv1DeliveryManuale.vue?vue&type=template&id=0e70dc83"
import script from "./Lv1DeliveryManuale.vue?vue&type=script&lang=js"
export * from "./Lv1DeliveryManuale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports